import { CreateProjectLicensesModel } from "../../../domain/projectLicenses/CreateProjectLicensesModel";
import httpClient from "../../http/httpClient";

export const LicensesRepository = {
    ActivateProjectLicense: (licenseId: number) => {
        return httpClient
            .patch(`/v1/licenses/${licenseId}/activate`, {})
            .then((response) => response);
    },

    InactivateProjectLicense: (licenseId: number) => {
        return httpClient
            .patch(`/v1/licenses/${licenseId}/inactivate`, {})
            .then((response) => response);
    },
    
    DonwloadProjectLicenses: (projectId: number) =>{
        return httpClient
            .get(
                '/projects/' + projectId + '/licenses/export', 
            )
            .then((response) => response);
    },

    CreateProjectLicenses: (projectId: number, createProjectLicensesModel : CreateProjectLicensesModel) =>{
        return httpClient
            .post(
                '/projects/' + projectId + '/licenses',
                createProjectLicensesModel
            )
            .then((response) => response);
    },

    GetProjectsLicensesList: (projectId: string) => {
        return httpClient
            .get('/projects/' + projectId + '/licenses/filter')
            .then((response) => response);
    },
}